// src/components/ModuleToolBarShell.tsx
import React from "react";
import { Box, Group } from "@mantine/core";

interface ModuleToolBarShellProps {
  children: React.ReactNode;
}

export const ModuleToolBarShell: React.FC<ModuleToolBarShellProps> = ({ children }) => {
  return (
    <Box
      bg="gray.0"
      px="md"
      py={10}
      style={{
        borderBottom: "1px solid var(--mantine-color-gray-3)",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        zIndex: 9,
      }}
    >
      <Group align="center" gap="md">
        {children}
      </Group>
    </Box>
  );
};
